module.exports = __webpack_public_path__ + "static/media/mkv.3e696b15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/mkv.svg
// module id = 1694
// module chunks = 17